<template>
  <div class="nav-background">
    <a v-for="card in filteredCardNames" :key="card.id" :href="'#' + card.id">
      <div
        class="outer-nav-circle position-relative"
      >
        <div
          class="nav-circle"
          :class="{
            'bg-idle': !card.visible,
            'bg-active': card.visible,
          }"
        ></div>
        <h6
          class="position-absolute nav-label"
        >
          {{ card.title }}
        </h6>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'ShipmentNavProgress',
  props: {
    cardNames: {
      type: Array,
      required: true,
    },
  },
  computed: {
    filteredCardNames() {
      return this.cardNames.filter((card) => !card.hide);
    },
  },
};
</script>

<style scoped>
.outer-nav-circle {
  height: 20px;
  width: 20px;
  background: rgba(0,0,0,0);
  border-radius: 50%;
  margin: 2px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all .2s ease;
}

.outer-nav-circle:hover {
  background: rgba(0,0,0,.5);
}

.bg-active {
  background: var(--hover-color);
}

.bg-idle {
  background: var(--accent-color);
}

.nav-label {
  left: 0;
  top: 0;
  padding: 0 10px;
  background: rgba(0, 0, 0, 0.3);
  white-space: nowrap;
  border-radius: 20px;
  color: white;
  opacity: 0;
  pointer-events: none;
  transition: all .2s ease;
}

.outer-nav-circle:hover .nav-label {
  left: 30px;
  opacity: 1;
}

.nav-circle {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  /*border: 3px solid red;*/
  /*font-size: 50%;*/
}

.nav-background {
  padding: 2px 5px 2px;
  background: #dbdbdb;
  border-radius: 20px;
  display: grid;
}
</style>
